import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss'],
  standalone: false
})
export class ContentLayoutComponent implements OnInit {
  constructor( private cdr: ChangeDetectorRef) { }

  ngOnInit() {
  }
}
